/* eslint no-unused-vars: 'off', arrow-parens: 'off', no-param-reassign: 'off' */

// The above eslint rules are disabled because we wanted to follow The
// usual notation that can be found on the docs when writing middlewares
import { registerHandler, unregisterHandler } from 'event-bus';
import { v as bvVar } from 'bv';
import { updateOutcome } from './duck';

const outcomeUpdateHandler = (_, { body: data }) => {
  const { store } = window.reduxState;

  // pcatalog field <= mao field
  data.hidden = data.h;
  if (data.po) {
    data.op = data.po;
  }

  // pretend we are receiving this field so we can support
  // changing it from 0 => null on updates.
  // missing field means it has changed to null for this one
  if (!('mblDistance' in data)) {
    data.mblDistance = null;
  }

  store.dispatch(updateOutcome(data.oid, data));
};

const outcomesMiddleware = store => next => action => {
  let outcomes;
  let outcomeIds;

  switch (action.type) {
    case 'ADD_OUTCOMES':
    case 'UPSERT_OUTCOMES':
      outcomes = store.getState().outcomes || {};

      (action.outcomes || []).forEach((outcome) => {
        if (!outcomes[outcome.id]) {
          registerHandler(`/outcome/${outcome.id}/brand/${bvVar('brandId')}`, outcomeUpdateHandler);
        }
      });
      break;

    case 'REMOVE_OUTCOMES':
      outcomes = store.getState().outcomes || {};
      outcomeIds = (action.outcomeIds || []).map(id => parseInt(id, 10));
      Object.keys(outcomes).map(el => parseInt(el, 10)).forEach((outcomeId) => {
        const outcome = outcomes[outcomeId];

        // If the outcome in question will be removed (before remove it's refCount === 1,
        // we unsubscribe from it
        if (outcomeIds.includes(outcomeId) && outcome && outcome.refCount === 1) {
          unregisterHandler(`/outcome/${outcome.id}/brand/${bvVar('brandId')}`, outcomeUpdateHandler);
        }
      });
      break;

    default:
      break;
  }

  next(action);
};

export default outcomesMiddleware;
